(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/syndicate-information.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/syndicate-information.js');
'use strict';

const SyndicateInformation = _ref => {
  let {
    isSyndicateMember = false,
    isSyndicateOwner = false
  } = _ref;
  return React.createElement(React.Fragment, null, (isSyndicateMember || isSyndicateOwner) && React.createElement("p", null, "V\xE4lj om du vill f\xE5 e-post med uppdateringar om h\xE4ndelser i ditt lag i Spela tillsammans."), !isSyndicateMember && !isSyndicateOwner && React.createElement("p", null, "N\xE4r du \xE4r med i ett lag ser du dina inst\xE4llningar h\xE4r. Tillsammans med dina v\xE4nner i ett lag kan ni spela fler rader \xE4n n\xE4r du spelar sj\xE4lv, och p\xE5 s\xE5 s\xE4tt \xF6ka dina chanser f\xF6r en vinst.", ' ', React.createElement("a", {
    className: "u-text-reset u-text-decoration-underline",
    href: svs.core.urlMapping.get('playTogetherCreateTeams')
  }, "Skapa ett lag h\xE4r")));
};
svs.myProfile.react.pages.notifications.components.SyndicateInformation = SyndicateInformation;

 })(window);